import getCollectionNameUtil from 'pages/Product/containers/Description/components/Breadcrumb/utils/get-collection-name'

const getCollectionUrlUtil = ({ productVariant }) => {
  const collectionName = getCollectionNameUtil({ productVariant }) || ''
  let collectionNameFormatted = collectionName.toLowerCase().replace(/ /g, '-')

  if (collectionNameFormatted === 'airshop+') {
    collectionNameFormatted = 'airshop'
  }

  return `/collections/${collectionNameFormatted}`
}

export default getCollectionUrlUtil
